import React from "react";
import { PersonalizationValue, TriggerStepCreate } from "@dots-projects/types";
import { useForm } from "react-hook-form";
import produce from "immer";
import { saveDraft, updateStep } from "./reducer/actionCreators";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import invariant from "ts-invariant";
import { StepFormWithCommonParts } from "./TriggerStepForm";
import { FormLabel } from "./FormLabel";
import TriggerEditorDiscordTextEditor from "./TriggerEditorDiscordTextEditor";

export function StepFormTestCaptcha({
  step,
  insertVariables,
}: {
  step: TriggerStepCreate;
  insertVariables: PersonalizationValue[];
}) {
  invariant(step.type === "test_captcha");
  let defaultValues = {
    name: step.name,
    htmlSucceedMessage: step.configs.$$succeedEditorHtmlMessage,
    message: step.configs.message,
    htmlFailMessage: step.configs.$$failEditorHtmlMessage,
    failMessage: step.configs.failMessage,
    ephemeral: step.configs.ephemeral,
  };
  const form = useForm({
    defaultValues,
    mode: "onChange",
  });
  const { handleSubmit } = form;
  const { state, dispatch, onPersist } = useTriggerEditorStateDispatch();
  const readOnly = !state.trigger.current.isDraft;

  const onSubmit = (data: any) => {
    // This uses the immer library to create a new copy of step (with updates)
    // without affecting the original step.
    const newStep = produce(step, (stepDraft) => {
      stepDraft.name = data.name;
      stepDraft.configs.message = data.message;
      stepDraft.configs.$$succeedEditorHtmlMessage = data.htmlSucceedMessage;
      stepDraft.configs.failMessage = data.failMessage;
      stepDraft.configs.$$failEditorHtmlMessage = data.htmlFailMessage;
      stepDraft.configs.ephemeral = data.ephemeral;
      stepDraft.configs.channelId = step.configs.channelId;
    });

    dispatch(updateStep(newStep));
    dispatch(saveDraft(onPersist));
  };
  return (
    <StepFormWithCommonParts
      onSubmit={handleSubmit(onSubmit)}
      form={form}
      step={step}
    >
      <FormLabel label="Message to send">
        <TriggerEditorDiscordTextEditor
          form={form}
          htmlField="htmlSucceedMessage"
          markdownField="message"
          insertVariables={insertVariables}
          defaultValue={step.configs.message}
          readOnly={readOnly}
        />
      </FormLabel>
      <FormLabel label="What message to send when they fail?">
        <TriggerEditorDiscordTextEditor
          form={form}
          htmlField="htmlFailMessage"
          markdownField="failMessage"
          insertVariables={insertVariables}
          defaultValue={step.configs.failMessage}
          readOnly={readOnly}
        />
      </FormLabel>
    </StepFormWithCommonParts>
  );
}
